module.exports = __webpack_public_path__ + "static/staw-krzeslo-2036e652e74c445992c5390f58d86165.jpg";